import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "header", "onExpand", "onCollapse"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { Box } from '@miro-site/core';
import Header from './Header';
import Content from './Content';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Item = function Item(_ref) {
  var children = _ref.children,
      header = _ref.header,
      onExpand = _ref.onExpand,
      onCollapse = _ref.onCollapse,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var onClick = function onClick() {
    if (!isExpanded && onExpand) {
      onExpand();
    }

    if (isExpanded && onCollapse) {
      onCollapse();
    }

    setIsExpanded(!isExpanded);
  };

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    as: "section"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Header, {
      onClick: onClick,
      isExpanded: isExpanded,
      children: header
    }), /*#__PURE__*/_jsx(Content, {
      isExpanded: isExpanded,
      children: children
    })]
  }));
};

export default Item;